import { Component, Output, Input, EventEmitter, OnInit, AfterViewInit } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { BeneficiaryInfo } from '../../models/enrollments'
import { RequiredRadioButtonFieldValidator } from '../../../validations/required-radio-button-field-validator'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { EmailAddressTextFieldValidator } from '../../../validations/email-address-text-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'
@Component({
    selector: 'beneficiary-info',
    templateUrl: './beneficiary-information.component.html'
})
export class BeneficiaryInformationComponent implements OnInit {
    @Input() enrollment: BeneficiaryInfo
    @Input() disabled: boolean = false
    @Output() onValueChange: EventEmitter<BeneficiaryInfo> = new EventEmitter<BeneficiaryInfo>()

    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ""
    genderOption: string = ""


    notBlankValidator = new NotBlankGenericFieldValidator()
    dateTextFieldValidator = new DateTextFieldValidator()
    numericTextFieldValidator = new NumericTextFieldValidator()
    requiredRadioButtonValidator = new RequiredRadioButtonFieldValidator()
    emailAddressTextFieldValidator = new EmailAddressTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    phoneNumberInputMask = new PhoneNumberInputMask()
    enrollmentViewModel: EnrollmentViewModel
    status: string
    constructor(private route: ActivatedRoute, private router: Router, private _enrollementGateway: EnrollmentGateway) { }
    ngOnInit() {
        this.getParams()
        if (this.status == "In Progress" || this.status == "Failed" || this.status == "Correction") {
            this.disabled = false
        }
        this.enrollment = {} as BeneficiaryInfo
        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]

        this.genderOptions = [
            { value: 'M', htmlLabel: 'Male' },
            { value: 'F', htmlLabel: 'Female' }
        ]

        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()

        if (this.enrollmentViewModel.beneficiaryInfo !== undefined) {
            this.enrollment = this.enrollmentViewModel.beneficiaryInfo
            this.genderOption = this.enrollment.gender
            this.titleOption = this.enrollment.title

            this.updateInfo('gender', this.genderOption)
            this.updateInfo('title', this.titleOption)
        }
    }

    public loadGoBackData(): void {
        this.genderOption = this.enrollmentViewModel.APPGEN
        this.titleOption = this.enrollmentViewModel.TITLE
    }
    updateInfo(fieldName: string, fieldValue: string) {
        console.log(fieldValue)
        if (fieldName == 'medicareId') {
            this.enrollment.medicareId = ''
            this.enrollment.medicareId = fieldValue.toUpperCase()
            this.enrollment[fieldName] = fieldValue.toUpperCase()
            //if (fieldValue.indexOf('-') >= 0) {
            //    fieldValue = fieldValue.replace('-', '')
            //    this.enrollment.medicareId = fieldValue.toUpperCase()
            //    this.enrollment[fieldName] = fieldValue.toUpperCase()
            //}
            this.onValueChange.emit(this.enrollment)
        } else {
            this.enrollment[fieldName] = fieldValue
            this.onValueChange.emit(this.enrollment)
        }

    }

    onHICNBlur() {
        console.log(this.enrollment.medicareId)
        if (this.enrollment.medicareId.indexOf('-') >= 0) {
            let re = /\-/gi
            let updatedHICN = this.enrollment.medicareId.replace(re, '')
            this.enrollment.medicareId = updatedHICN.toUpperCase()
            this.enrollment['medicareId'] = updatedHICN.toUpperCase()
            this.onValueChange.emit(this.enrollment)
        }
    }
    getParams() {
        this.route.params.forEach((params: Params) => {
            this.status = this.route.snapshot.params['id']
        })
}
}
